import React from "react";

export default function EmptyState({
  title = "We will update soon",
  subtitle = "New content is coming shortly. Please check back later.",
  icon = "play",
}) {
  const renderIcon = () => {
    // All icons use same viewBox and size to avoid visual offset
    if (icon === "arrow") {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-gray-400">
          <path d="M9.75 6.75a.75.75 0 011.06 0l4.5 4.5a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 11-1.06-1.06L13.94 12 9.75 7.81a.75.75 0 010-1.06z" />
        </svg>
      );
    }
    // default 'play' icon
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-gray-400">
        <path d="M8 5v14l11-7z" />
      </svg>
    );
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-6 rounded-2xl border border-dashed border-gray-300 bg-white/60">
        <div className="mx-auto mb-3 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
          {renderIcon()}
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
      </div>
    </div>
  );
}


